module.exports = __webpack_public_path__ + "img/user-18.25ee2095.svg";